import moment from 'moment';
import {
  ChevronLeft,
  ChevronRight,
  DatePickerButton,
  Datepicker,
  DatePickerContainer,
  StyledCheckbox,
  TimesheetsHeader,
} from './styles/TimesheetsTableHeader.styled';
import { DayOfWeek } from '@fluentui/react';
import { DateRangeType, addDays } from '@fluentui/react';
import { useCallback, useMemo } from 'react';
import { useWeekStartDate } from '../../context/weekStartDate';
import { useTimesheetsContext } from '../../context/TimeSheet/TimesheetsContext';
interface TimeSheetsTableHeaderProps {
  setWeekStartDate: React.Dispatch<React.SetStateAction<Date>>;
  setAnyPopupsOpen: (value: boolean) => void;
}

export const TimesheetsTableHeader = ({
  setWeekStartDate,
  setAnyPopupsOpen,
}: TimeSheetsTableHeaderProps) => {
  const weekStartDate = useWeekStartDate();
  const { showInactivePeriods, setShowInactivePeriods } =
    useTimesheetsContext();
  const onPreviousWeekClick = useCallback(() => {
    setAnyPopupsOpen(false);
    setWeekStartDate((prev) => addDays(prev, -7));
  }, []);

  const onNextWeekClick = useCallback(() => {
    setAnyPopupsOpen(false);
    setWeekStartDate((prev) => addDays(prev, 7));
  }, []);

  const selectedWeekHeader = useMemo(() => {
    const weekEndDate = moment(weekStartDate).endOf('isoWeek').toDate();

    return (
      <div>
        <span>
          {moment(weekStartDate).format('DD')}-
          {moment(weekEndDate).format('DD MMM')}
        </span>{' '}
        <span>{weekEndDate.getFullYear()}</span>
      </div>
    );
  }, [weekStartDate]);

  const onWeekChange = (date: Date | null) => {
    const currentWeekStartDate = moment(date).startOf('isoWeek').toDate();
    setWeekStartDate(currentWeekStartDate);
  };

  const labelText = 'Show Inactive Assignments';

  return (
    <TimesheetsHeader>
      <DatePickerContainer>
        <div>
          <DatePickerButton>{selectedWeekHeader}</DatePickerButton>

          <Datepicker
            id="id"
            openOnClick
            calendarProps={{
              dateRangeType: DateRangeType.Week,
            }}
            isMonthPickerVisible={false}
            firstDayOfWeek={DayOfWeek.Monday}
            disableAutoFocus={true}
            borderless={true}
            value={weekStartDate}
            onSelectDate={onWeekChange}
          />
        </div>
        <DatePickerButton onClick={onPreviousWeekClick}>
          <ChevronLeft />
        </DatePickerButton>
        <DatePickerButton onClick={onNextWeekClick}>
          <ChevronRight />
        </DatePickerButton>
        <StyledCheckbox
          checked={showInactivePeriods}
          label={labelText}
          onChange={() => setShowInactivePeriods((prev) => !prev)}
        />
      </DatePickerContainer>
    </TimesheetsHeader>
  );
};
